(function () {
  'use strict';

  var bar = document.querySelector('[data-nbr-sticky-atc]');
  if (!bar) return;

  var submitBtn = bar.querySelector('[data-nbr-sticky-submit]');
  var priceEl = bar.querySelector('[data-nbr-sticky-price]');

  function getRealForm() {
    return document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function getRealSubmit(form) {
    return form ? form.querySelector('.product-form__submit') : null;
  }

  function syncFromRealButton() {
    var form = getRealForm();
    var realSubmit = getRealSubmit(form);
    if (!realSubmit || !submitBtn) return;
    submitBtn.disabled = realSubmit.disabled;
    submitBtn.textContent = realSubmit.textContent.trim();
  }

  function syncPrice() {
    var priceWrapper = document.querySelector('.product .price, .product__info-wrapper .price');
    if (!priceWrapper || !priceEl) return;
    var visiblePrice = priceWrapper.querySelector('.price-item--regular, .price-item--sale');
    if (visiblePrice) {
      priceEl.textContent = visiblePrice.textContent.trim();
    }
  }

  var mainSubmit = document.querySelector('.product-form__submit');

  if (mainSubmit && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (window.innerWidth >= 750) {
            bar.hidden = true;
            return;
          }
          bar.hidden = false;
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(mainSubmit);
  }

  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var form = getRealForm();
      if (!form) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  }

  syncFromRealButton();
  syncPrice();

  var priceWrapperForObserver = document.querySelector('.product .price, .product__info-wrapper .price');
  if (priceWrapperForObserver && 'MutationObserver' in window) {
    new MutationObserver(function () {
      syncPrice();
      syncFromRealButton();
    }).observe(priceWrapperForObserver, { childList: true, subtree: true, characterData: true });
  }
})();
